import {httpGet,httpPut,httpDelete,httpPost} from '../../../util/request.js';
import appConfig from '../../../config';

export default class HttpRequestMethodApi{

	
	static QUERY_HTTP_REQUEST_METHOD_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/sys/httpRequestMethods";
	
	static queryHttpRequestMethod(){
		let params={};
		return httpGet(HttpRequestMethodApi.QUERY_HTTP_REQUEST_METHOD_API_URL,params);
	}
	
}